import * as React from 'react';
import { connect } from 'react-redux';
import { signUp } from '../../actions/newsletterAction';
import * as Cookie from '../../helpers/cookie';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import { IPageDataReducer } from '../../reducers/pageData';
import { NewsletterButton } from './NewsletterButton';

declare let google: any;

interface IStateToProps {
    pageData: IPageDataReducer;
}

interface IProps extends IStateToProps {
    signUp: Function;
    active: boolean;
}

interface IState {
    buttonVisible: boolean;
    email: string;
    loaded: boolean;
}

class GoogleOneTapClass extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            buttonVisible: false,
            email: '',
            loaded: false,
        };
    }

    componentDidMount() {
        if (Cookie.readCookie('oneTapEmail')) {
            return this.setState({
                email: Cookie.readCookie('oneTapEmail'),
                buttonVisible: true,
            });
        }

        if (
            !this.props.active ||
            this.state.loaded ||
            typeof google !== 'undefined' ||
            !(
                this.props.pageData.brandConfig.googleOneTapClientId &&
                this.props.pageData.brandConfig.googleOneTapClientId.length > 0
            )
        ) {
            return;
        }

        if (
            window.location.protocol !== 'https:' ||
            typeof MutationObserver === 'undefined' ||
            typeof window.navigator === 'undefined' ||
            /MSIE|Trident/.exec(window.navigator.userAgent) !== null
        ) {
            return;
        }

        let body = document.getElementsByTagName('body')[0],
            tag = document.createElement('script');

        tag.type = 'text/javascript';
        tag.async = true;

        tag.addEventListener('load', () => {
            if (Cookie.readCookie('oneTapEmail')) {
                this.setState({
                    email: Cookie.readCookie('oneTapEmail'),
                    buttonVisible: true,
                });
            } else if (
                this.props.active === true &&
                !Cookie.readCookie('oneTap') &&
                this.props.pageData.brandConfig.googleOneTapClientId &&
                typeof google !== 'undefined' &&
                this.props.pageData.brandConfig.googleOneTapClientId.length > 0
            ) {
                try {
                    this.googleOneTap();
                } catch (error) {
                    console.error(error);
                }
            }
        });

        tag.src = '//accounts.google.com/gsi/client';
        body.appendChild(tag);
    }

    decodeJWT(token: string) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
        );

        return JSON.parse(jsonPayload);
    }

    subscriptionCallback(e: any) {
        const credential = this.decodeJWT(e.credential);

        Cookie.writeCookie('oneTap', '1', 7);
        Cookie.writeCookie('oneTapEmail', credential.email, 7);
        this.setState({
            buttonVisible: true,
            email: credential.email,
        });
        eventTracker.track({
            category: 'Google One Tap',
            action: 'One Tap submit',
            label: window.location.href,
            event: 'click',
        });

        return;
    }

    googleOneTap() {
        google.accounts.id.initialize({
            client_id: this.props.pageData.brandConfig.googleOneTapClientId,
            callback: (e: any) => this.subscriptionCallback(e),
        });

        google.accounts.id.prompt((notification) => {
            if (notification.isDisplayed()) {
                eventTracker.track({
                    category: 'Google One Tap',
                    action: 'One Tap shows',
                    label: window.location.href,
                    event: 'click',
                });
            }
        });
    }

    render() {
        return (
            <NewsletterButton
                isVisible={this.state.buttonVisible}
                email={this.state.email}
                signUp={this.props.signUp}
                portalId={this.props.pageData.brandConfig.portalId}
            />
        );
    }
}

const mapStateToProps = (state: IStateToProps) => ({
    pageData: state.pageData,
});
const mapDispatchToProps = { signUp };

export const GoogleOneTap = connect<IStateToProps, {}, any>(
    mapStateToProps,
    mapDispatchToProps,
)(GoogleOneTapClass);
